import { createContext } from "react";
/**
 * Allows access of layout control props via context
 */
export const ControlLayoutContext = createContext({});
ControlLayoutContext.displayName = "ControlLayoutContext";
//# sourceMappingURL=ControlLayoutContext.js.map